import { t } from '@lingui/core/macro'
import { ImageOff, Pencil, Star } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const Tile = styled.button`
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 0.3rem;
  overflow: hidden;
  background: var(--muted);
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid var(--ring);
    outline-offset: 2px;
  }
`

const TileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Placeholder = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--muted-foreground);
`

const EditIcon = styled.span`
  position: absolute;
  right: 0.15rem;
  bottom: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--foreground);
  pointer-events: none;
`

const HeroBadge = styled.span`
  position: absolute;
  left: 0.15rem;
  bottom: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 0.2rem;
  background: var(--background);
  color: var(--foreground);
  pointer-events: none;
`

export const PhotoTile: React.FC<{
  imageUrl: string | undefined
  label: string
  pending: boolean
  pendingHint: string
  isHero?: boolean
  canEdit: boolean
  onOpen: () => void
  className?: string
}> = ({
  imageUrl,
  label,
  pending,
  pendingHint,
  isHero = false,
  canEdit,
  onOpen,
  className,
}) => (
  <Tile
    type='button'
    className={className}
    title={pending ? `${label} — ${pendingHint}` : label}
    onClick={onOpen}>
    {imageUrl ? (
      <TileImage src={imageUrl} alt={label} />
    ) : (
      <Placeholder aria-hidden>
        <ImageOff size={16} />
      </Placeholder>
    )}
    {isHero && (
      <HeroBadge role='img' aria-label={t`Hero`} title={t`Hero`}>
        <Star size={12} fill='currentColor' aria-hidden />
      </HeroBadge>
    )}
    {canEdit && (
      <EditIcon aria-hidden>
        <Pencil size={14} />
      </EditIcon>
    )}
  </Tile>
)
